import styled from "styled-components";
import { COLOUR_CONSTANT } from "../../utils/contants";

export const RevenueForecastStyled = styled.div`
  .header {
    margin: 5px 36px;
    border-bottom: 1px solid #dedafb;
    min-height: 45px;
    display: flex;
    align-items: center;
  }

  .parent-div {
    width: 100%;
    display: flex;
    position: relative;
  }

  .class-check {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
  }
  .filterwrapper {
    display: flex;
    justify-content: space-between;
    width: 100%;
    min-width: 0;
    .drawer {
      width: 100%;
    }
    .override {
      position: static;
    }
    .filter-lists {
      padding-left: 35px;
    }
    .visible {
      top: 50px;
    }
    .apply {
      padding-right: 40px;
    }
  }

  .content-box {
    .content-head {
      display: flex;
      padding: 12px 36px;
      width: 100%;
      gap: 16px;
      min-width: 0;

      .forecastStart {
        display: flex;
        gap: 8px;
        min-width: fit-content;
        align-items: baseline;
        .forecast-date {
          display: flex;
          align-items: center;
          min-width: fit-content;
          font-weight: 500;
        }
      }
    }
    .content {
      height: auto;
      min-height: 400px;
      padding: 12px 36px;
      .btn-style {
        margin-top: 5px;
        display: flex;
        justify-content: end;
      }
    }
  }
  .list {
    margin-top: 40px;
  }
  .forecasted-table {
    .MuiPaper-root {
      height: calc(100vh - 200px);
      overflow-y: auto;
    }
    thead {
      tr {
        & th:nth-child(1) {
          position: sticky !important;
          left: 0;
          opacity: 1;
          z-index: 3;
          background-color: ${COLOUR_CONSTANT.theme.purple.light};
        }
        & th:nth-child(2) {
          position: sticky !important;
          left: 79px;
          opacity: 1;
          z-index: 3;
          background-color: ${COLOUR_CONSTANT.theme.purple.light};
        }
      }
    }
    tbody {
      tr {
        & td:nth-child(1) {
          position: sticky !important;
          left: 0;
          z-index: 2;
          opacity: 1;
          background-color: ${COLOUR_CONSTANT.theme.purple.light};
        }

        & td:nth-child(2) {
          position: sticky !important;
          left: 79px;
          z-index: 2;
          opacity: 1;
          background-color: ${COLOUR_CONSTANT.theme.purple.light};
        }
      }
    }

    tfoot {
      position: sticky;
      bottom: 0;
      background-color: ${COLOUR_CONSTANT.theme.background.dark};
      z-index: 3;

      .MuiTableRow-root {
        background-color: ${COLOUR_CONSTANT.theme.background.dark};
        font-weight: bold;

        .MuiTableCell-root {
          border-top: 1px solid ${COLOUR_CONSTANT.theme.purple.medium};
          padding: 10px 16px;
          text-align: right !important;
        }
      }
    }
  }
`;
